import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function IconCarousel({
  className,
  width,
  height,
  id,
  color,
  hoverColor,
  viewBox,
}) {
  const [mainColor, setMainColor] = useState(color);

  useEffect(() => {
    if (color !== mainColor) {
      setMainColor(color);
    }
  }, [color]);

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
    >
      <defs>
        <path
          id="m1wnml2pta"
          d="M15 4c1.657 0 3 1.343 3 3v9c0 1.657-1.343 3-3 3H9c-1.657 0-3-1.343-3-3V7c0-1.657 1.343-3 3-3h6zm7.6 0v1.6h-.8c-.513 0-.936.386-.993.883L20.8 6.6v9.8c0 .513.386.936.883.993l.117.007h.8V19h-.8c-1.38 0-2.51-1.076-2.595-2.435L19.2 16.4V6.6c0-1.38 1.076-2.51 2.435-2.595L21.8 4h.8zM2.2 4l.165.005C3.724 4.09 4.8 5.22 4.8 6.6v9.8l-.005.165C4.71 17.924 3.58 19 2.2 19h-.8v-1.6h.8l.117-.007c.497-.057.883-.48.883-.993V6.6l-.007-.117c-.057-.497-.48-.883-.993-.883h-.8V4h.8zM15 5.6H9c-.728 0-1.326.555-1.394 1.265L7.6 7v9c0 .728.555 1.326 1.265 1.394L9 17.4h6c.728 0 1.326-.555 1.394-1.265L16.4 16V7c0-.728-.555-1.326-1.265-1.394L15 5.6z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0H228V44H0z"
                transform="translate(-164 -1049) translate(140 767) translate(0 272)"
              />
              <g transform="translate(-164 -1049) translate(140 767) translate(0 272) translate(24 10)">
                <path d="M0 0H24V24H0z" />
                <mask id={id} fill="#fff">
                  <use xlinkHref="#m1wnml2pta" />
                </mask>
                <g fill={mainColor} mask={`url(#${id})`}>
                  <path d="M0 0H24V24H0z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

IconCarousel.defaultProps = {
  className: undefined,
  width: 24,
  height: 24,
  color: '#BDBDBD',
  hoverColor: '#fff',
  viewBox: '0,0,24,24',
  id: undefined,
};

IconCarousel.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
};

export default IconCarousel;
